<div
  class="summary-card"
  [ngClass]="{ bordered: info && info.bordered, 'dashed-border': info && info.dashedBorder, 'is-missing': isMissing }"
  *ngIf="info"
>
  <div class="summary-card-logo" *ngIf="info.imgSrc">
    <div class="card-logo d-flex">
      <img src="assets/icons/{{ info.imgSrc }}.svg" alt="{{ info.title | translate }}" />
    </div>
  </div>
  <div class="summary-card-content">
    <div class="summary-card-header">
      <div [style.display]="'flex'">
        <!-- <img src="assets/icons/attention.svg"
                     class="atten-icon"> -->
        <h5>{{ info.title | translate }}{{ index ? index : "" }}</h5>
      </div>
      <div class="pr-2" *ngIf="canEdit && canDelete; else oneAction">
        <dropdown-action [iconColor]="iconColor" [menuMode]="menuMode" [id]="'bill-' + index">
          <button dropdown-item class="dropdown-item" (click)="gotoEdit()">{{ "BUTTON.EDIT" | translate }}</button>
          <button dropdown-item class="dropdown-item" (click)="isBLConfirmModalOpen = true">{{ "BUTTON.DELETE" | translate }}</button>
        </dropdown-action>
      </div>
      <ng-template #oneAction>
        <div class="summary-card-edit" *ngIf="canEdit">
          <button class="btn btn-link" (click)="gotoEdit()"><i class="fa fa-pencil"></i></button>
        </div>
      </ng-template>
    </div>
    <div class="container-card-body" [ngClass]="{ 'empty-image': info.emptyImage }">
      <ng-content *ngIf="!isMissing; else missingMessage"></ng-content>
      <ng-template #missingMessage>{{ "ENTRY_SUMMARY.REQUIRED_INFORMATION" | translate }}</ng-template>
    </div>
  </div>
</div>

<custom-modal [header]="'LABELS.DELETE_BL'" [(open)]="isBLConfirmModalOpen">
  <div>{{ "DELETE_ITEM_TEXT" | translate }}</div>

  <button footer-action type="button" class="btn btn-primary" (click)="onDelete()">{{ "LABELS.YES" | translate }}</button>

  <button footer-action type="button" class="btn btn-secondary ml-2" (click)="isBLConfirmModalOpen = false">
    {{ "LABELS.NO" | translate }}
  </button>
</custom-modal>
